export default __webpack_public_path__ + "static/media/circle-sapphire-icon.85ac841a.svg";